// A Turbo morph (page refresh, a refresh="morph" frame reloading, a morph
// stream) keeps Stimulus controllers connected but resets every class and
// attribute they set to the server markup, so connect() never gets a chance to
// put them back. Idiomorph fires turbo:morph-element on each element it
// morphs, which bubbles, so listening on the controller's element catches a
// morph of the element itself or anything inside it. The callback runs once
// per morph, after it finishes. Returns the unsubscribe for disconnect().
export function afterMorph(element, callback) {
  let queued = false

  const handler = () => {
    if (queued) return

    queued = true
    queueMicrotask(() => {
      queued = false
      if (element.isConnected) callback()
    })
  }

  element.addEventListener("turbo:morph-element", handler)

  return () => element.removeEventListener("turbo:morph-element", handler)
}
